import * as React from 'react';
import { connectMapRefinement } from '../connectors/connectMapRefinement';
class AutocompleteInput extends React.Component {
    inputRef;
    autocomplete;
    constructor(props, context) {
        super(props, context);
        this.inputRef = React.createRef();
        this.placesChanged = this.placesChanged.bind(this);
    }
    componentDidMount() {
        const current = this.inputRef.current;
        this.autocomplete = new this.props.google.maps.places.Autocomplete(current);
        // When the Google Places dropdown is open, let Google commit the highlighted
        // prediction (which fires place_changed) and stop the form from submitting the
        // stale typed text. With no dropdown showing, fall through to the normal
        // free-text (church name) submit.
        current?.addEventListener('keydown', (evt) => {
            if (evt.key !== 'Enter') {
                return;
            }
            const pac = document.querySelector('.pac-container');
            const dropdownOpen = !!pac && pac.offsetParent !== null && !!pac.querySelector('.pac-item');
            if (dropdownOpen) {
                evt.preventDefault();
            }
        }, true);
        this.autocomplete.addListener('place_changed', () => this.placesChanged());
    }
    render() {
        const { 
        // google maps provided
        google, loaded, 
        // map refinement connector provided
        refine, createURL, currentRefinement, 
        // our defined prop
        onPlaceChanged, ...inputProps } = this.props;
        return React.createElement("input", { ...inputProps, ref: this.inputRef });
    }
    placesChanged() {
        if (!this.autocomplete) {
            return;
        }
        const places = this.autocomplete.getPlace();
        if (!places) {
            return;
        }
        if (!places.geometry) {
            return;
        }
        this.props.refine({
            selectedPlace: {
                name: places.name,
                types: places.types,
                location: {
                    lat: places.geometry.location.lat(),
                    lng: places.geometry.location.lng(),
                },
                viewport: places.geometry.viewport.toJSON()
            },
            expandSearch: false,
        });
        if (this.props.onPlaceChanged) {
            this.props.onPlaceChanged(places);
        }
    }
}
const ConnectedAutocompleteInput = connectMapRefinement(AutocompleteInput);
export default ConnectedAutocompleteInput;
